/** Chance de êxito (processo/caso): seletor e etiqueta colorida. */
export const CHANCE_LABEL: Record<string, string> = { muito_alta: "Muito alta", alta: "Alta", media: "Média", baixa: "Baixa", muito_baixa: "Muito baixa" };
export const CHANCE_ORDER = ["muito_alta", "alta", "media", "baixa", "muito_baixa"] as const;
const TONE: Record<string, string> = { muito_alta: "#15803d", alta: "#16a34a", media: "#d97706", baixa: "#dc2626", muito_baixa: "#991b1b" };

export function ChanceSelect({ value, onChange, emptyLabel = "Não avaliada" }: { value: string; onChange: (v: string) => void; emptyLabel?: string }): JSX.Element {
  return (
    <select className="input" value={value} onChange={(e) => onChange(e.target.value)}>
      <option value="">{emptyLabel}</option>
      {CHANCE_ORDER.map((k) => <option key={k} value={k}>{CHANCE_LABEL[k]}</option>)}
    </select>
  );
}

export function ChanceBadge({ value }: { value: string | null | undefined }): JSX.Element | null {
  if (!value) return null;
  return <span className="chance-badge" style={{ borderColor: TONE[value], color: TONE[value] }}>Chance {CHANCE_LABEL[value]?.toLowerCase() ?? value}</span>;
}
